// 操作成功
export const OPERATE_SUCCESS = "操作成功"
// 操作异常
export const OPERATE_EXCEPTION = "请求异常"
// 邮箱不能为空
export const EMAIL_FAILE = "邮箱不能为空"
// 邮箱不正确
export const EMAIL_EXCEPTION = "邮箱输入不正确"
// 电话不能为空
export const PHONE_FAILE = "电话不能为空"
// 手机号码校验失败
export const MOBILE_FAILE = "不是完整的11位手机号或者正确的手机号"
// 用户名或密码错误
export const LOGIN_FAILE = "用户名或密码错误"
// 用户名不能为空
export const LOGIN_USER_EMPTY = "用户名不能为空"
// 密码不能为空
export const LOGIN_PASSWORD_EMPTY = "密码不能为空"
// 两次密码必须相等
export const PASSWORD_EQUAL = "两次密码必须相等"
// 登录异常
export const LOGIN_EXCEPTION = "登录异常"
// 成功登录
export const LOGIN_SUCCESS = "成功登录"
// 确认退出
export const LOGINOUT_ENSURE = "确认要退出登录？"
// 退出异常
export const LOGINOUT_EXCEPTION = "退出异常"
// 查询无信息
export const SEARCH_NOTEXIST = "无符合条件的信息"
// 确认删除
export const DELETE_ENSURE = "确定删除该{1}吗？"
// 确认新建
export const ADD_ENSURE = "确定新建该{1}吗？"
// 确认编辑
export const EDIT_ENSURE = "确定保存对该{1}的修改吗？"
// 删除成功
export const DELETE_SUCCESS = "删除成功"
// 删除失败
export const DELETE_FAILE = "删除失败"
// 获取失败
export const GET_FAILE = "{1}获取失败"
// 信息为空
export const INFO_EMPTY = "{1}信息为空"
// 信息异常
export const INFO_EXCEPTION = "{1}异常"
// 确认保存
export const SAVE_ENSURE = "确定保存吗？"
// 确认保存
export const SAVE_ENSURE_INFO = "确定保存{1}是{2}的{3}吗？"
// 确认删除
export const DELETE_ENSURE_INFO = "确定删除{1}是{2}的{3}吗？"
// 确认选择
export const SELECT_ENSURE = "信息未选择"
// 确认选择
export const SELECT_VEHICLE = "没有选择车辆"
// 删除判断 
export const DELETE_NO = "{1}不能删除"
// 菜单获取异常
export const MENU_EXCEPTION = "菜单获取异常"

// 成功发送
export const SEND_SUCCESS = "信息已成功发送到您的邮箱"
// 重置车辆密码成功
export const RESET_VEHICLE_SUCCESS = "重置车辆密码成功"

// 导出失败
export const EXPORT_EXCEPTION = "导出失败"




// WEBPACK FOOTER //
// ./src/static/message.js